// extracted by mini-css-extract-plugin
module.exports = {"no-result-data-area":"no-result-data-area___2R8m2","no-result-data-img":"no-result-data-img___8eiil","no-result-data-text":"no-result-data-text___379v6"};